/**
 * ChatHeader Component
 * Header with title, model indicator, and control buttons
 */

import React from 'react';

/**
 * Trash icon for clear button
 */
function TrashIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    </svg>
  );
}

/**
 * Maximize/Fullscreen icon
 */
function MaximizeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
      <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
    </svg>
  );
}

/**
 * Exit fullscreen icon
 */
function MinimizeFullscreenIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
      <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>
    </svg>
  );
}

/**
 * X icon for close
 */
function XIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );
}

/**
 * Format model name for display
 */
function formatModelName(model) {
  if (!model) return null;
  
  if (model.includes('gpt-4.1-mini')) return '4.1 mini';
  if (model.includes('gpt-4.1')) return 'GPT-4.1';
  if (model.includes('gpt-4')) return 'GPT-4';
  
  return model;
}

function ChatHeader({ 
  model = null,
  isComplexQuery = false,
  isFullscreen = false,
  onClear,
  onMinimize,
  onToggleFullscreen,
  onClose
}) {
  const modelDisplay = formatModelName(model);

  return (
    <div className="chatbot-header">
      <div className="chatbot-header-left">
        {/* Avatar */}
        <div className="chatbot-avatar rf-bob-orb-mark" aria-hidden="true">B</div>
        
        {/* Title and subtitle */}
        <div className="chatbot-title-group">
          <h3 className="chatbot-title">Bob</h3>
          <div className="chatbot-subtitle">
            <span>Rapid Fusion Assistant</span>
            {modelDisplay && (
              <span className="chatbot-model-badge">{modelDisplay}</span>
            )}
          </div>
        </div>
      </div>
      
      <div className="chatbot-header-actions">
        {/* Clear conversation button */}
        <button
          className="chatbot-header-btn danger"
          onClick={onClear}
          type="button"
          title="Clear conversation"
          aria-label="Clear conversation"
        >
          <TrashIcon />
        </button>
        
        {/* Fullscreen toggle */}
        <button
          className="chatbot-header-btn"
          onClick={onToggleFullscreen}
          type="button"
          title={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
          aria-label={isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
        >
          {isFullscreen ? <MinimizeFullscreenIcon /> : <MaximizeIcon />}
        </button>
        
        {/* Close/Minimize button */}
        <button
          className="chatbot-header-btn"
          onClick={onClose}
          type="button"
          title="Close"
          aria-label="Close chat"
        >
          <XIcon />
        </button>
      </div>
    </div>
  );
}

export default ChatHeader;
